import { truncateString } from '../../packages/kiti/utils/helpers/string'
import { useQuestionsFromApi } from '../helpers/questions'

const genRawQuestionInterpolationValue = (question, repliesOrigin) => {
  switch (question.typeName) {
    case 'float':
    case 'numeric':
    case 'decimal':
      return `{{#find ${repliesOrigin} field="question_id" operator="eq" value=${question.id}}}{{raw reply.value}}{{/find}}`
    case 'user':
      return `::{{#find ${repliesOrigin} field="question_id" operator="eq" value=${question.id}}}{{reply.value.id}}{{/find}}`
    case 'date':
    case 'datetime':
      return `{{#find ${repliesOrigin} field="question_id" operator="eq" value=${question.id}}}{{raw reply.value}}{{/find}}`
    case 'gallery':
      return `{{#find ${repliesOrigin} field="question.id" operator="eq" value=${question.id}}}{{to_urls reply.value}}{{/find}}`
    default:
      return `{{#find ${repliesOrigin} field="question_id" operator="eq" value=${question.id}}}{{reply.value}}{{/find}}`
  }
}

const NUMERIC_TYPES = ['float', 'numeric', 'decimal']
const QUESTIONS_TYPES = ['user', 'date', 'datetime', 'float', 'numeric', 'decimal', 'calc', 'gallery']

export const useRawRepliesInterpolationsFetcher = (skip, repliesOrigin, checklistId) => {
  const { data: questionsData } = useQuestionsFromApi(checklistId, QUESTIONS_TYPES, { skip })

  const questions = questionsData?.questions || []

  return questions
    .filter(question => {
      if (question.typeName === 'block') return false
      if (question.insideBlock && !NUMERIC_TYPES.includes(question.typeName)) return false
      return true
    })
    .map(question => {
      return {
        name: truncateString(question.name, 30),
        fullName: question.name,
        description: truncateString(question.category?.name, 30),
        id: genRawQuestionInterpolationValue(question, repliesOrigin),
        type: `raw_${question.typeName}`,
        nodeType: 'interpolation',
        group: 'Respostas'
      }
    })
}
